import MetaTags from "./index";
import { useMemo } from "react";

function tags(type) {
  const ext = (() => {
    if (type === "complete") {
      return "リセット完了";
    } else if (type === "reset") {
      return "再設定";
    } else {
      return "リセット";
    }
  })();
  return {
    vod: {
      title: `パスワード${ext} | スカパー！動画ストア`,
      keywords: "スカパー！動画ストア,動画配信,見放題,レンタル",
      description: `パスワード${ext}。スカパー！動画ストアではサッカー・プロレス・格闘技などの動画を配信中！`,
      og: { type: "article" },
    },
  };
}

export default function PasswordRemindMetaTags({ type }) {
  const props = tags(type)["vod"];

  const noindex = useMemo(() => {
    if (type) {
      return "noindex";
    } else {
      return null;
    }
  }, [type]);

  return <MetaTags {...props} robots={noindex} />;
}
